// src/modules/app-views/goodsReceipt/components/CardHeaderGoodsReceiptSubtitle.jsx
// *******************************************************************************
// CARD HEADER SUBTITLE: Supplier CNPJ/CPF | City - UF
// *******************************************************************************
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import useZustand from 'hooks/useZustand';
import translateX from 'utils/translateX';
import { parseCnpjToDisplay, parseCpfToDisplay, isCpfOrCnpj } from 'utils/helpers';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CardHeaderGoodsReceiptSubtitle = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const currentPage = useZustand?.('module', 'currentPage', false);

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const data = currentPage?.data;
  const isNew = !data?._id || data?._id === 'add';

  if (isNew) {
    return <span>{translateX('new_goods_receipt')}</span>;
  }

  // Build supplier document label (CNPJ or CPF)
  const issuer = data?.issuer || {};
  const cpfCnpj = issuer?.cpfCnpj || '';
  const documentType = isCpfOrCnpj(cpfCnpj);

  let docLabel;
  if (documentType === 'cnpj') {
    docLabel = `CNPJ: ${parseCnpjToDisplay(cpfCnpj)}`;
  } else if (documentType === 'cpf') {
    docLabel = `CPF: ${parseCpfToDisplay(cpfCnpj)}`;
  } else if (cpfCnpj) {
    docLabel = `ID: ${cpfCnpj}`;
  } else {
    docLabel = 'CNPJ: N/A';
  }

  // Build location (City - UF)
  const city = issuer?.address?.city;
  const uf = issuer?.address?.region;
  const location = city && uf ? `${city} - ${uf}` : city || uf || '';

  const subtitle = location ? `${docLabel} | ${location}` : docLabel;

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <span>{subtitle}</span>;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderGoodsReceiptSubtitle;
